import styled from "styled-components";
import TableContainer from "@material-ui/core/TableContainer";

const CheckboxTableContainer = styled(TableContainer)`
    background: rgba(214, 235, 255, 0.4);
`;

export default CheckboxTableContainer;
